export interface ResistanceLog {
  depthRepsThreshold: number
  depthSuccessThreshold: number
  evaluation: any
  form: number
  level: string
  name: string
  reps: number
  resistanceNumber: number
  sets: number
  stoppedCount: number
}

export const evaluationHashes: string[] = [
  '運動記録がありません',
  'フォームやペースをうまくコントロールしましょう',
  'もう少しがんばりましょう！',
  'この調子でがんばりましょう！',
  'すばらしい！！この調子でがんばりましょう！！',
]



// WEBPACK FOOTER //
// ./src/interfaces/resistance-log.ts